import { Link, useRouterState } from "@tanstack/react-router";
import { useIsAdmin } from "../lib/auth";

export function NavLinks() {
  const routerState = useRouterState();
  const pathname = routerState.location.pathname;
  const isAdmin = useIsAdmin();

  const navItems = [
    { href: "/", label: "Songs" },
    { href: "/setlists", label: "Setlists" },
    { href: "/about", label: "About" },
    ...(isAdmin ? [{ href: "/admin/users", label: "Users" }] : []),
  ];

  return (
    <nav className="order-3 flex w-full gap-6 sm:order-2 sm:w-auto">
      {navItems.map(({ href, label }) => {
        const isActive =
          href === "/" ? pathname === "/" : pathname.startsWith(href);

        return (
          <Link
            key={href}
            to={href}
            className={`text-sm transition-colors ${
              isActive
                ? "text-amber"
                : "text-text-secondary hover:text-text-primary"
            }`}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
